import { render, staticRenderFns } from "./ss-banner-new.vue?vue&type=template&id=0d42d756&scoped=true"
import script from "./ss-banner-new.vue?vue&type=script&lang=js"
export * from "./ss-banner-new.vue?vue&type=script&lang=js"
import style0 from "./ss-banner-new.vue?vue&type=style&index=0&id=0d42d756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42d756",
  null
  
)

export default component.exports